import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { logo } from "../../../assets/img";

import {
  registerUser,
  getEmployeeById,
  updateEmployee,
} from "../../../api/register";

import EmpPersonalDetails from "../../../Components/EmployeeAdd/EmpPersonalDetails";
import EmpQualificationDetails from "../../../Components/EmployeeAdd/EmpQualificationDetails";
import EmpExperienceDetails from "../../../Components/EmployeeAdd/EmpExperienceDetails";

const emptyExperience = {
  companyname: "",
  location: "",
  designation: "",
  joiningDate: "",
  relievingDate: "",
  experience: "",
};

const AddEmployee = () => {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("personal");
  const [loading, setLoading] = useState(false);

  const [personalData, setPersonalData] = useState({});
  const [qualificationData, setQualificationData] = useState({});
  const [experienceData, setExperienceData] = useState([emptyExperience]);
const formatDate = (date) => {
  if (!date || typeof date !== "string") return "";
  return date.split("T")[0];
};

  const handleStepChange = (step) => setActiveSection(step);

  // ✅ FETCH DATA
  const fetchEmployee = useCallback(async () => {
    try {
      const res = await getEmployeeById(id);

      console.log("API RESPONSE:", res.data);

      const emp = res.data.employee || res.data;

      setPersonalData({
        ...emp,
        dob: formatDate(emp?.dob),
      });

      setQualificationData(emp?.qualification || {});

      setExperienceData(
        Array.isArray(emp?.experience) && emp.experience.length > 0
          ? emp.experience
            .filter((exp) => exp && typeof exp === "object") // ✅ remove null
            .map((exp) => ({
              ...exp,
              joiningDate: exp?.joiningDate ? formatDate(exp.joiningDate) : "",
              relievingDate: exp?.relievingDate ? formatDate(exp.relievingDate) : "",
            }))
          : [{ ...emptyExperience }]
      );
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch employee");
    }
  }, [id]);

  useEffect(() => {
    if (isEditMode) fetchEmployee();
  }, [fetchEmployee, isEditMode]);

  // ✅ SUBMIT
  const handleFinalSubmit = async () => {
    try {
      setLoading(true);

      const finalData = {
        ...personalData,
        qualification: qualificationData,
        experience: experienceData.filter(Boolean),
      };

      if (isEditMode) {
        await updateEmployee(id, finalData);
        toast.success("Employee Updated Successfully ✅");
      } else {
        await registerUser(finalData);
        toast.success("Employee Added Successfully ✅");
      }

      navigate("/employees-list");
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="d-flex ac-js my-2 register-header">
        <img src={logo} className="logo" alt="logo" />
        <h1 className="employee mt-2">
          {isEditMode ? "Edit Employee Details" : "New Employee Registration"}
        </h1>
      </div>

      <div className="step-buttons">
        <button
          className={`step-btn ${activeSection === "personal" ? "active" : ""}`}
          onClick={() => handleStepChange("personal")}
        >
          Personal Details
        </button>

        <button
          className={`step-btn ${activeSection === "qualification" ? "active" : ""
            }`}
          onClick={() => handleStepChange("qualification")}
        >
          Qualification Details
        </button>

        <button
          className={`step-btn ${activeSection === "experience" ? "active" : ""
            }`}
          onClick={() => handleStepChange("experience")}
        >
          Experience Details
        </button>
      </div>

      <div className="form-card">
        {activeSection === "personal" && (
          <EmpPersonalDetails data={personalData} setData={setPersonalData} />
        )}

        {activeSection === "qualification" && (
          <EmpQualificationDetails
            data={qualificationData}
            setData={setQualificationData}
          />
        )}

        {activeSection === "experience" && (
          <EmpExperienceDetails
            data={experienceData}
            setData={setExperienceData}
          />
        )}
      </div>

      <button
        className="register_btn mt-4 mb-4"
        onClick={handleFinalSubmit}
        disabled={loading}
      >
        {loading
          ? "Processing..."
          : isEditMode
            ? "Update Employee"
            : "Register Employee"}
      </button>
    </div>
  );
};

export default AddEmployee;